import script from "./OrderHeadComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderHeadComponent.vue?vue&type=script&setup=true&lang=ts"

import "./OrderHeadComponent.vue?vue&type=style&index=0&id=47367cf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47367cf2"]])

export default __exports__